<template>
    <div class="xi" style="background: #F5F5F5;">
        <hd-com></hd-com>
        <div class="banner">
            <div class="banner-text">
                <p>当前位置：<router-link to="/index">首页</router-link>
                    <i class="el-icon-arrow-right"></i><router-link to="/reservation/reservationIndex">医院列表</router-link>
                    <i class="el-icon-arrow-right"></i><a>医院详情</a>
                </p>
            </div>
        </div>
        <div class="content">
            <div class="bannerImg">
                <div class="contentListDoc">
                    <div class="contentListDocTop">
                        <div class="DocTopImg">
                            <img v-if="hosOrgDetail.logoFile " :src="http + hosOrgDetail.logoFile">
                            <img v-else src="../../assets/img/reservation/touxiang03.png" alt="">
                        </div>
                        <div class="DocTopImgR">
                            <div class="DocTopFlexS">
                                <div class="DocTopImgRT">
                                    <span class="DocTopImgName">{{hosOrgDetail.name}}</span>
                                </div>
                            </div>
                            <div class="DocTopImgRT" style="margin-top:5px">
                                <div class="DocTopTagZ" v-if="hosOrgDetail.levelName">{{hosOrgDetail.levelName}}</div> 
                                <div class="DocTopTagZLev" v-if="hosOrgDetail.specialtyTypeName">{{hosOrgDetail.specialtyTypeName}}</div>
                                <div class="DocTopTagZLev">{{hosOrgDetail.natureType == 0 ? '私立医院' : '公立医院'}}</div>
                            </div>
                            <div class="DocTopImgRT" style="margin-top:15px">
                                <i class="el-icon-location-outline"></i>
                                <span style="margin-left:5px">{{hosOrgDetail.regionFullName ? hosOrgDetail.regionFullName : '暂无地址'}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-top">
                <div class="diagnose-tab">
                    <span :class="orgTable == 0 ? 'active' : '' " @click="getTab(0)">主页</span>
                    <span :class="orgTable == 1 ? 'active' : '' "  @click="getTab(1)">医院介绍</span>
                </div>
            </div>
        </div>
        <div class="contentRes">
            <div class="contentList">
                <div style="padding: 20px 30px; background: #FFFFFF;" v-if="orgTable == 0 && StuDataList.length > 0">
                    <div class="contentPriceBox" style="display: flex;align-items: center;justify-content: space-between;">
                        <div class="contentListTop" style="margin-bottom:10px;cursor: pointer;">
                            <div class="contentListLine"></div><span>专科中心</span>
                        </div>
                        <div style="font-size: 16px;color: #00AFB5; cursor: pointer;" @click="getAllTab">全部中心<i class="el-icon-arrow-right"></i></div>
                    </div>
                    <div class="gHConcenterBox" style="margin-bottom: 10px;cursor: pointer;" v-if="StuDataList.length > 0">
                        <div class="stuBox" v-for="(item,index) in StuDataList" :key="index" @click="goDetail(item)">
                            <img v-if="index == 0" src="../../assets/img/consultation/pczk01.png" mode="" />
                            <img v-if="index == 1" src="../../assets/img/consultation/pczk02.png" mode="" />
                            <img v-if="index == 2" src="../../assets/img/consultation/pczk03.png" mode="" />
                            <div class="stuBoxPos">
                                <div style="font-weight: bold;font-size: 20px;color: #333333;" class="gHstuRightTitle">
                                    {{item.name}}
                                </div>
                                <div class="" style="font-size: 16px;color: #666666;">
                                    {{item.expertise}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="padding: 20px 30px; background: #FFFFFF;margin-top:20px" v-if="orgTable == 0">
                    <div class="contentPriceBox" style="display: flex;align-items: center;justify-content: space-between;">
                        <div class="contentListTop" style="margin-bottom:10px">
                            <div class="contentListLine"></div><span>医院介绍</span>
                        </div>
                        <div style="font-size: 16px;color: #00AFB5; cursor: pointer;" @click="getTab(1)">查看完整介绍<i class="el-icon-arrow-right"></i></div>
                    </div>
                    <div class="desDoc" v-if="hosOrgDetail.abstract"><p v-html="replace(hosOrgDetail.abstract)"></p></div>
                </div>
                <div style="padding: 20px 30px; background: #FFFFFF;margin-top:20px" v-if="orgTable == 1">
                    <div class="contentPriceBox">
                        <div class="contentListTop" style="margin-bottom:10px">
                            <div class="contentListLine"></div><span>医院介绍</span>
                        </div>
                    </div>
                    <div v-if="hosOrgDetail.abstract"><p v-html="replace(hosOrgDetail.abstract)"></p></div>
                </div>
                <div style="padding: 20px 30px; background: #FFFFFF;margin-top:20px" v-if="orgTable == 0">
                    <div class="contentPriceBox">
                        <div class="contentListTop" style="margin-bottom:10px">
                            <div class="contentListLine"></div><span>医生列表</span><span style="margin-left:10px;color: #666666;font-size: 16px;margin-top:3px">挂号预约医院医生</span>
                        </div>
                    </div>
                    <div class="contentListTop3" style="margin-bottom:20px;position: relative;margin-top:20px" @click="selectPostClick">
                        <div :class="setTab == 1 ? 'filterBoxCheck' : ''" @click.stop="selectPost(1)">
                            <span class="searchNameTitle">综合排序<i class="el-icon-arrow-down" style="margin-left: 5px;"></i></span>
                        </div>
                        <div :class="setTab == 2 ? 'filterBoxCheck' : '' " @click.stop="selectPost(2)">
                            <span class="searchNameTitle">{{departmentName ? departmentName : '科室'}} <i class="el-icon-arrow-down" style="margin-left: 5px;"></i></span>
                        </div>
                        <div :class="setTab == 3 ? 'filterBoxCheck' : '' " @click.stop="selectPost(3)">
                            <span class="searchNameTitle">{{hosTitleName ? hosTitleName : '职称'}} <i class="el-icon-arrow-down" style="margin-left: 5px;"></i></span>
                        </div>
                          <el-date-picker
                            v-model="SelectDate"
                            type="date"
                            placeholder="选择日期"
                            value-format="yyyy-MM-dd"
                            @change="dataChange"
                            >
                            
                        </el-date-picker>
                        <div :class="isSelectExpert ? 'filterBoxBtnCheck' : 'filterBoxBtn'" style="margin-left: 100px;" @click="selectExpert">
                            只看专家
                        </div>
                        <div class="allDiseaseBox" v-if="setTabFalse" ref="mainShowBox">
                            <div class="" v-if="setTab == 2" style="margin-bottom: 50px;">
                                <div style=" display: flex;margin-top:10px">
                                    <div class="SelectTagBox">
                                        <div  v-for="(item,index) in hosDepartmentList" :key="index" :class="departmentId == item.id ? 'SelectTagCheck' : 'SelectTag' " @click.stop="godepType(item,index)">
                                            {{item.name}}
                                        </div>
                                    </div>
                                </div>
                                <div class="resetBtnBoxBot">
                                    <div class='resetBtnBox' @click.stop="setSearchType">重置</div>
                                    <div  class='sureBtnBox' @click.stop="goSearchType">确定</div>
                                </div>
                            </div>
                            <div class="" v-if="setTab == 3" style="margin-bottom: 50px;">
                                <div style=" display: flex;margin-top:10px">
                                    <div >
                                        <div  v-for="(item,index) in hosTitleList" :key="index" class="SelectTagBox" >
                                            <div v-for="(item1,index1) in item.children" :key="index1" :class="hosTitleIndex == item1.id ? 'SelectTagCheck' : 'SelectTag' " @click.stop="goTitleType(item1,index)">
                                                 {{item1.userTitleName}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="resetBtnBoxBot">
                                    <div class='resetBtnBox' @click.stop="setSearchType">重置</div>
                                    <div  class='sureBtnBox' @click.stop="goSearchType">确定</div>
                                </div>
                            </div>
                            <!-- <div class="" v-if="setTab == 4" style="margin-bottom: 50px;">
                                <div style=" display: flex;margin-top:10px">
                                     <el-date-picker
                                        v-model="SelectDate"
                                        type="date"
                                        placeholder="选择日期"
                                        value-format="yyyy-MM-dd"
                                        @change="dataChange"
                                        >
                                        </el-date-picker>
                                </div>
                                <div class="resetBtnBoxBot">
                                    <div class='resetBtnBox' @click.stop="setSearchType">重置</div>
                                    <div  class='sureBtnBox' @click.stop="goSearchType">确定</div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                        <div class="contentListDocList" v-for="(item,index) in hosDocList" :key="index">
                            <div class="contentListDocTop">
                                <div class="DocTopImgOrg">
                                    <img v-if="item.photoFile " :src="http + item.photoFile" alt="" srcset="">
                                    <img v-else src="../../assets/img/reservation/touxiang03.png" alt="">
                                </div>
                                <div class="DocTopImgRorg">
                                    <div class="DocTopImgRTorg">
                                        <span class="DocTopImgNameOrg">{{item.userName}}</span>
                                        <img v-if="item.certificateNumber" src="../../assets/img/reservation/ilabel.png" style="width:60px;height:18px" alt="" srcset="">
                                        <!-- <div v-if="item.levelName == 1" class="DocTopTagZ">{{item.levelName}}</div> -->
                                        <div v-if="item.userCategoryType == 1" class="DocTopTagZ">专家</div>
                                    </div>
                                    <div class="DocTopFlexC" style="font-size: 14px;color: #333333;">
                                        <span>{{item.hospitalDeptName}}</span>
                                        <span style="margin:0 5px">|</span>
                                        <span>{{item.userTitleName}}</span>
                                        <span style="margin:0 5px">|</span>
                                        <span>{{item.userPostName}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="desDocOrg" style="" v-if="item.expertise">擅长:{{item.expertise}}</div>
                            <div class="DocTopFlexB" style="margin-top:5px;font-size: 14px;color: #666666;">
                                <div>
                                    <span style="margin-right:30px">问诊量： <span style="color:#00AFB5">{{item.orderCount}}</span></span>
                                    <span style="margin-right:30px">好评率：<span style="color:#00AFB5">{{item.goodRate + '%'}}</span></span>
                                    <span>评分：<span style="color:#00AFB5">{{item.starRate}}</span></span>
                                </div>
                            </div>
                            <div class='btnGreen' @click="goOrgDocDetai(item)">查看详情</div>
                        </div>
                    <div v-if="hosDocList.length == 0" style="margin-top:50px; display: flex;align-items: center;flex-direction: column;">
                        <img src="../../assets/img/reservation/adefault.png" style="width:256px;height:140px;" alt="" srcset="">
                        <span style="color: #666666;">暂无数据！</span>
                    </div>
                </div>
            </div>
            <div style="">
                <div class="contentListRight" style="height:120px" v-if="StuDataList.length > 0">
                    <el-carousel trigger="click" height="120px">
                        <el-carousel-item v-for="(item,index) in StuDataList" :key="index" >
                            <img :src="http + item.logoUrl" mode="" style="height: 120px; width: 100%;border-radius: 10px;" @click="goDetail(item)" />
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div class="contentListRight">
                    <div style="margin: 19px 31px 28px 23px;padding-top:20px">
                        <div class="contentListTopR">
                            <div class="contentListLineR"></div><span>温馨提示</span>
                        </div>
                        <div style="font-size: 16px;color: #FF0000;line-height: 24px;margin-top:18px">
                            本系统仅提供辅助参考功能，诊疗决策须由执业医师独立完成，提交的所有内容，仅您本人与医生可见，请放心！
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ft-com></ft-com>
    </div>
</template>

<script>
import { reservationMain } from "../../components/reservation/reservation";
import { consultationMain } from "../../components/consultation/consultation";
import hdCom from '../../components/header'
import ftCom from '../../components/footer'
export default {
    components: {
        hdCom,
        ftCom,
    },
    data() {
        var reservationMainItem = new reservationMain(this.TokenClient, this.Services.Authorization);
         var consultationMainItem = new consultationMain(this.TokenClient, this.Services.Authorization);
        return {
            reservationDomain: reservationMainItem,
            consultationDomain: consultationMainItem,
            hosOrgDetail:JSON.parse(this.$route.query.hosDetail),
            http:'',
            orgTable:0,
            evaluateList:[],
            hosDocList:[],
            setTabFalse:false,
            setTab:0,
            hosDepartmentList:[],
            departmentId:0,
            departmentName:'',
            hosTitleList:[],
            SelectDate:'',
            hosTitleIndex:-1,
            hosTitleId:0,
            hosTitleName:'',
            isSelectExpert:false,
            StuDataList:[]
        }
        
    },
    mounted(){
        this.http = this.Services.ossUpload;
        this.GetOrgDetialData()
        document.addEventListener("click", this.selectPostClick);
        this.getDocListData()
        this.GetStuDataListData()
    },
    beforeDestroy() {
        document.removeEventListener("click", this.selectPostClick);
    },
    methods: {
        getAllTab(){
            this.$router.push({
                path: "./studioList",
                query:{
                    id:this.hosOrgDetail.id
                }
            });
        },
        goDetail(e){
            this.$router.push({
                path: "./studioListDetail",
                query:{
                    id:e.id
                }
            });
        },
        GetStuDataListData(){
            var _this = this;
            _this.consultationDomain.GetAppletStudioGroupListStu(_this.hosOrgDetail.id,'1','-1',function (data) {
                if (data.data.length > 3) {
                    _this.StuDataList = data.data.slice(0,3)
                } else {
                    _this.StuDataList = data.data
                }
            },
            function (error) {
                 _this.StuDataList = []
                console.log('', error)
            })
        },
        goOrgDocDetai(e){
            console.log(e)
            console.log(this.hosOrgDetail)
            let params = {
                id:e.id,
                userName:e.userName,
                userCategoryType:e.userCategoryType,
                departmentName:e.departmentName,
                userPostName:e.userPostName,
                userTitleName:e.userTitleName,
                certificateNumber:e.certificateNumber,
                expertise:e.expertise,
                orgName:this.hosOrgDetail.name,
                specialtyTypeName:this.hosOrgDetail.specialtyTypeName,
                levelName:this.hosOrgDetail.levelName,
                orgRegionFullName:this.hosOrgDetail.regionFullName,
                photoFile: e.photoFile,
                onlineConsultationPrice:e.onlineConsultationPrice,
                phoneConsultationPrice:e.phoneConsultationPrice,
            }
            this.$router.push({
                path: "/reservation/reservationDoctorDetail",
                query: {
                    DocDetail: JSON.stringify(params),
                },
            });
        },
        dataChange(e){
            console.log(e)
            this.SelectDateSearch = e
            this.getDocListData()
        },
        selectExpert(){
            this.isSelectExpert = !this.isSelectExpert
            this.getDocListData()
        },
        goTitleType(e,index){
            this.hosTitleIndex = e.id
            this.hosTitleId = e.id
            this.hosTitleName = e.userTitleName
            //  this.setTabFalse = false
            // this.goSearchType()
        },
        goSearchType(){
             this.setTabFalse = false
             this.getDocListData()
        },
        setSearchType(){
            if (this.setTab == 2) {
                this.departmentId= 0
                this.departmentName = ''
            }
            if (this.setTab == 3) {
                this.hosTitleIndex = -1
                this.hosTitleId = ''
                this.hosTitleName = ''
            }
            if (this.setTab == 3) {
                this.SelectDate = ''
            }
        },
        GetHospitalDeptData(){
            var _this = this
            _this.reservationDomain.GetHospitalDept(function (data) {
                _this.hosDepartmentList = data.data
            },
            function (error) {
                 _this.hosDepartmentList = []
                console.log('', error)
            })
        },
        godepType(e,index){
            this.departmentId = e.id
            this.departmentName = e.name
            // this.goSearchType()
        },
        selectPost(e){
            this.setTab = e
            if (e == 1) {
                this.getDocListData()
            }
            if (e == 2) {
                 this.setTabFalse = true
                this.GetHospitalDeptData()
            }
            if (e ==3) {
                this.setTabFalse = true
                this.GetUserTitleData()
            }
            if (e ==4) {
                this.setTabFalse = true
                // this.GetUserTitleData()
            }
        },
         GetUserTitleData(){
             // 写死yunhis  net的 productId == 4
			// 写死yunhis 线上 的 productId == 2
             var _this = this;
            _this.consultationDomain.GetUserTitle('2',function (data) {
                _this.hosTitleList = data.data
            },
            function (error) {
                 _this.hosTitleList = []
                console.log('', error)
            })
        },
        selectPostClick(e) {
            if (!this.$refs.mainShowBox.contains(e.target) && this.$refs.mainShowBox) {
                this.setTabFalse = false
            }
        },
        replace(content) {
            return content.replace(/\n/g, '</p> <p>')
        },
        getTab(e){
            this.orgTable = e
        },
        GetOrgDetialData(){
            var _this = this
            _this.reservationDomain.GetOrgDetial(_this.hosOrgDetail.id,function (data) {
                _this.hosOrgDetail.abstract = data.data.abstract
            },
            function (error) {
                 _this.hosOrgDetail = {}
                console.log('', error)
            })
        },
        getDocListData(){
            var _this = this
            let hosTitleIdSearch = _this.hosTitleId == '' ? '%20' : _this.hosTitleId
            let SelectDateSearch = _this.SelectDate == '' || !_this.SelectDate  ? '%20' : _this.SelectDate
            let SelectExpert = _this.isSelectExpert ? '1' : '-1'
            _this.reservationDomain.GetorgDoctorList(_this.hosOrgDetail.id, _this.departmentId, hosTitleIdSearch, SelectExpert , SelectDateSearch, function (data) {
                _this.hosDocList = data.data
            },
            function (error) {
                 _this.hosDocList = {}
                console.log('', error)
            })
        },
    },
}
</script>

<style scoped>
.banner-text {
    width: 1200px;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 10px;
}
.content {
  width: 1200px;
    margin: 0 auto;
}
.contentRes {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    min-height: 800px;
    margin-bottom: 20px;
}
.bannerImg {
    /* height: 150px; */
    background: linear-gradient(90deg, #00AFB5, #12C7AC);
    border-radius: 6px 6px 0px 0px;
}
.content-top {
  height: 64px;
  background: #ffffff;
  box-shadow: 2px 0 5px rgba(102, 102, 102, 0.08);
}
.diagnose-tab {
    padding: 20px 30px;
    padding-bottom: 0px;
    cursor: pointer;
    border-radius: 0px 0px 6px 6px;
}
.diagnose-tab span {
  margin-right: 50px;
  color: #808080;
  font-size: 16px;
   padding-bottom: 20px;
}

.diagnose-tab span.active {
  color: #00A8AE;
  border-bottom: 2px solid #00A8AE;
}
.contentList {
    margin-top: 20px;
   
    width: 800px;

}
.contentListTop {
    display: flex;
    align-items: center;
    font-size: 20px;
}
.contentListLine {
    width: 3px;
    height: 20px;
    background: #00AFB5;
    border-radius: 2px;
}
.contentListTop span {
   font-size: 20px;
   margin-left: 10px;
}
.contentListRight {
    width: 380px;
    height: 180px;
    background: #FFFFFF;
    margin-top: 20px;
    cursor: pointer;
}
.contentListTopR {
    display: flex;
    align-items: center;
}
.contentListLineR {
    width: 3px;
    height: 20px;
    background: #FF0000;
    border-radius: 2px;
}
.contentListTopR span {
   font-size: 20px;
   margin-left: 10px;
   color: #FF0000;
}
.contentListDoc {
   padding: 30px;
}
.contentListDocTop {
    display: flex;
    align-items: center;
}
.DocTopImg {
    width: 100px;
    height: 100px;
    position: relative;
}
.DocTopImg img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
}
.DocTopImgR {
    margin-left: 20px;
    border-radius: 8px;
    padding: 20px;
    padding-bottom: 15px;
    position: relative;
    width: 700px;
    background: #21c2b9;
    color: #ffffff;
    
}
.DocTopImgName {
    font-weight: bold;
    font-size: 18px;
    margin-right: 7px;
}
.DocTopImgRT {
    display: flex;
    align-items: center;
}
.DocTopFlexC {
    display: flex;
    align-items: center;
}
.DocTopFlexS {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.desDoc p {
     margin-top:10px;
    font-size: 16px;
    color: #666666;
    overflow: hidden;/*超出部分隐藏*/
    /* white-space: nowrap; */
    text-overflow:ellipsis;/*超出部分文字以...显示*/
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical
}
.desDocOrg {
     margin-top:10px;
    font-size: 16px;
    color: #666666;
    overflow: hidden;/*超出部分隐藏*/
    /* white-space: nowrap; */
    text-overflow:ellipsis;/*超出部分文字以...显示*/
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical
}
.DocTopTagZ {
    width: 40px;
    background: #677AEC;
    border-radius: 3px;
    font-size: 10px;
    padding: 2px 0px ;
    color: #FFFFFF;
    text-align: center;
    margin-right: 5px;
    margin-left: 5px;
}
.DocTopTagZLev {
    border-radius: 3px;
    background: #D68A5A;
    padding: 0 5px ;
    font-size: 12px;
    color: #FFFFFF;
    margin-right: 5px;
}
.contentListTop3 {
    display: flex;
    align-items: center;
     cursor: pointer;
}
.filterBoxCheck {
    color: #00AFB5;
}
.allDiseaseBox {
  position: absolute;
  top: 45px;
  left: 40px;
  width: 800px;
  padding: 30px 25px;
  background: #FFFFFF;
  box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.1);
  border: 1px solid #EBEBEB;
  min-height: 160px;
  overflow-y: auto;
  z-index: 999;
  /* position: relative; */
}
.SelectTagBox {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    flex: 1;
    width: 100%;
}
.SelectTagCheck {
    background: #E5F8F8;
    border-radius: 2px;
    font-size: 14px;
    color: #00A8AE;
    border-radius: 2px;
    padding: 5px 10px;
    margin-right: 10px;
    cursor: pointer;
    margin-bottom: 5px;
}
.SelectTag {
  color: #333333;
  padding: 5px 10px;
  font-size: 14px;
  margin-right: 10px;
  cursor: pointer;
  margin-bottom: 5px;
}
.resetBtnBox {
    width: 80px;
    background: #E9F2F2;
    border-radius: 4px;
    text-align: center;
    padding: 5px 0;
    font-size: 14px;
    color: #00A8AE;
    cursor: pointer;
}
.sureBtnBox {
    width: 80px;
    background: #00AFB5;
    border-radius: 4px;
    text-align: center;
    padding: 5px 0;
    font-size: 14px;
    color: #FFFFFF;
    margin-left: 10px;
     cursor: pointer;
}
.resetBtnBoxBot {
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 20px;
    right: 30px;
}
.filterBoxBtnCheck {
    width: 90px;
    background: #00AFB5;
    border-radius: 4px;
    font-size: 14px;
    color: #FFFFFF;
    text-align: center;
}
.filterBoxBtn {
    width: 90px;
    background: #F0F0F0;
    border-radius: 4px;
    font-size: 14px;
    color: #333333;
    text-align: center;
}
.contentListDocList {
    background: #F5FAF9;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
    position: relative;
}
.DocTopImgOrg {
    width: 60px;
    height: 60px;
    position: relative;
}
.DocTopImgOrg img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
}
.DocTopImgRorg {
    margin-left: 16px;

}
.DocTopImgRTorg  {
    display: flex;
    align-items: center;
}
.DocTopImgNameOrg {
    font-weight: bold;
    font-size: 18px;
    color: #333333;
    margin-right: 7px;
}
.btnGreen {
    width: 100px;
    background: #00AFB5;
    border-radius: 4px;
    text-align: center;
    color: #FFFFFF;
    font-size: 16px;
    text-align: center;
    padding: 5px 0;
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
}
.searchNameTitle {
    display: block;
    width: 120px;
    overflow: hidden;/*超出部分隐藏*/
    white-space: nowrap;/*不换行*/
    text-overflow:ellipsis;/*超出部分文字以...显示*/
}
.gHConcenterBox {
    display: flex;
    align-items: center;
}
.stuBox {
    width: 33%;
    height: 90px;
    position: relative;
    margin-right: 10px;
}
.stuBox img {
    width: 100%;
    height: 100%;
}
.stuBoxPos {
    position: absolute;
    top:10px;
    left:20px;
}
.gHstuRightTitle {
    color: #333333;
    max-width: 200px;
    overflow: hidden;/*超出部分隐藏*/
    white-space: nowrap;/*不换行*/
    text-overflow:ellipsis;/*超出部分文字以...显示*/
}
</style>
